import { Box, CircularProgress, Typography } from '@mui/material';
import { useEffect } from 'react';

import { useAuth } from './useAuth';

export const AuthCallbackPage = () => {
  const { isLoading, error, isAuthenticated, primaryEntity } = useAuth();

  useEffect(() => {
    if (isAuthenticated && primaryEntity) {
      // Redirect to the entity's dashboard after successful auth.
      // Using replace so the callback URL doesn't stay in history.
      window.location.replace(`/veterans-case-mgmt/${primaryEntity}/dashboard`);
    }
  }, [isAuthenticated, primaryEntity]);

  if (isLoading) {
    return (
      <Box
        display="flex"
        flexDirection="column"
        alignItems="center"
        justifyContent="center"
        minHeight="200px"
        height="100vh"
        gap={2}
      >
        <CircularProgress />
        <Typography variant="body1">Processing authentication...</Typography>
      </Box>
    );
  }

  if (error) {
    return (
      <Box
        display="flex"
        flexDirection="column"
        alignItems="center"
        justifyContent="center"
        minHeight="200px"
        height="100vh"
      >
        <Typography variant="h6" color="error">
          Authentication Error
        </Typography>
        <Typography variant="body1">{error.message}</Typography>
      </Box>
    );
  }

  if (isAuthenticated) {
    return (
      <Box
        display="flex"
        flexDirection="column"
        alignItems="center"
        justifyContent="center"
        minHeight="200px"
        height="100vh"
      >
        <Typography variant="h6">Authentication Successful</Typography>
        <Typography variant="body1">Redirecting...</Typography>
      </Box>
    );
  }

  return null;
};
